import { EMAIL_TEMPLATES_TABS } from "@/modules/email-templates-sidebar/constants";
import { useEmailTemplatesContext } from "@/modules/email-templates-sidebar/context";
import { EmailTemplateComposeTab } from "@/modules/email-templates-sidebar/content/v2/tabs/compose-tab";
import { EmailTemplatesSidebarHistoryTab } from "@/modules/email-templates-sidebar/content/v2/tabs/history-tab";

export const EmailTemplatesSidebarPrimaryContent = () => {
  const { activeTab } = useEmailTemplatesContext();

  return (
    <>
      {activeTab === EMAIL_TEMPLATES_TABS.COMPOSE && (
        <EmailTemplateComposeTab />
      )}

      {activeTab === EMAIL_TEMPLATES_TABS.HISTORY && (
        <EmailTemplatesSidebarHistoryTab />
      )}
    </>
  );
};
